export const MICROSERVICES_GATEWAY = process.env.REACT_APP_MICROSERVICES_GATEWAY;
export const VIDEO_INTERVIEWING_GATEWAY = `${MICROSERVICES_GATEWAY}/video-interviewing`;
